document.querySelector(".re-calc").addEventListener("click", function () {
  document.getElementById("calculation-result").style.display = "none";
  document.querySelector(".calculate-btn-js").style.display = "block";
  document.querySelector("#room-length-number").value = "";
  document.querySelector("#room-width-number").value = "";
  document.querySelector("#room-full-square").value = "";
});
document
  .querySelector(".calculate-btn-js")
  .addEventListener("click", function () {debugger;
    const productType = document.getElementById("product-type").value;
    const length =
      parseFloat(document.getElementById("room-length-number").value) || 0;
    const width =
      parseFloat(document.getElementById("room-width-number").value) || 0;
    const squareFootage =
      parseFloat(document.getElementById("room-full-square").value) || 0;
    const unit = document.getElementById("measurement-unit").value;

    // Get the buffer value from the selected product's `data-value` attribute
    const buffer =
      document.querySelector("#product-type option:checked").dataset.value || 0;

    // Calculate area to cover based on square footage or length/width
    let areaToCover = calculateAreaToCover(
      squareFootage,
      length,
      width,
      unit,
      buffer / 100
    );

    if (areaToCover === null) {
      alert("Please enter valid values.");
      return;
    }
    displayResults(productType, areaToCover, unit);
  });

// Function to calculate area to cover
function calculateAreaToCover(squareFootage, length, width, unit, buffer) {debugger;
  if (squareFootage > 0) {
    return Math.ceil(squareFootage * (1 + buffer));
  } else if (length > 0 && width > 0) {
    // For length/width calculation
    return length * width * (1 + buffer);
  }
  return null; // Invalid input
}
// Function to display results
function displayResults(productType, areaToCover, unit) {
  
 let ac = areaToCover; 
      if(unit == "cm"){
        ac = Math.ceil(areaToCover *  0.01);
      }
      if(unit == "in"){
        ac = Math.ceil(areaToCover * 0.0254)
      }
  if (["tiles", "planks"].includes(productType)) {
    let packCoverage = 1;
    if(document.querySelector(".coverage-info")){
      packCoverage = parseFloat(document.querySelector(".coverage-info").getAttribute("data-coverage")) || 6;
    }
    
      
    const packages = Math.ceil(ac / packCoverage);
    document.querySelector(".output-1").style.display = "inline-block";
    document.querySelector(".output-2").classList.remove("center");
    document.getElementById(
      "packagesResult"
    ).innerHTML = `<strong>${packages}  ${ packages > 1 ? 'Packages' : 'Package'}</strong>`;
  } else {
    document.querySelector(".output-1").style.display = "none";
    document.querySelector(".output-2").classList.add("center");
    
  }
 document.getElementById("toCoverResult").textContent = 
     ac + ' m²';
  document.getElementById("calculation-result").style.display = "block";
  document.querySelector(".calculate-btn-js").style.display = "none";
}

// Handle Measurement Unit Change
const selectMeasurement = document.getElementById("measurement-unit");
const inputWrappers = document.querySelectorAll(".unit-label");

selectMeasurement.addEventListener("change", function () {debugger;
  const selectedValue = selectMeasurement.value;
  inputWrappers.forEach((wrapper) => {
    wrapper.textContent = selectedValue;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const selectBox = document.querySelector('.custom-select');
  const selectedOption = document.querySelector('.selected-option');
  const optionsList = document.querySelector('.dropdown-options');
  const options = document.querySelectorAll('.dropdown-option');

  // Toggle the dropdown on click
  if( selectBox ){
    selectBox.addEventListener('click', function () {
      this.classList.toggle('active');
    })
  }

  // Set selected option and close the dropdown
  options.forEach(option => {
    option.addEventListener('click', function () {
      selectedOption.textContent = this.textContent;
      selectBox.classList.remove('active');
    });
  });

  // Close the dropdown if clicked outside
  document.addEventListener('click', function (event) {
    if (selectBox && !selectBox.contains(event.target)) {
      selectBox.classList.remove('active');
    }
  });
});

